<template>
  <div>
    <BListFilter
      v-model="form"
      label="Поиск по названию"
      :skeleton="skeleton"
      dense
      @change="onChangeDebounced"
    />
  </div>
</template>

<script>
import BListFilter, { createDefaultData } from '@/components/forms/BListFilter.vue'


const createDefaultDataFilters = () => ({
  ...createDefaultData(),
})

export default {
  name: 'FormTemplatesFilter',
  components: {
    BListFilter,
  },
  extends: BListFilter,
  props: {
    skeleton: Boolean,
    data: {
      type: Object,
      default: createDefaultDataFilters,
    },
  },
}
</script>
